export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-700-2267169ee7270a22a963b2b2bfb7ab0c.woff";